<template>
	<div>
		<v-form ref="form" v-model="isFormValid" lazy-validation>
			<modal
				:exibir="exibir"
				:titulo="tituloModal"
				:max-width="modalOptions.largura"
				:min-height="modalOptions.altura"
				:is-confirmar-visivel="isConfirmarVisivel"
				:custom-actions="false"
				:acao-cancelar="fecharModal"
				:acao-confirmar="tratarEventoEstornar"
				nome-botao-confirmar="Estornar"
				:nome-botao-cancelar="nomeBotaoCancelar"
				:tamanho="modalOptions"
				@close="fecharModal"
			>
				<template #body>
					<div class="my-1">
						<estornar-item-pedido
							v-if="isEstornar"
							:itens="itens"
							:lista-possui-um-item="listaPossuiUmItem"
							@estornar="estornar"
							@limpar-formulario="recarregarFormulario"
						></estornar-item-pedido>
						<detalhes-estornar-item-pedido
							v-if="!isEstornar"
							:item-selecionado="itens[0]"
						></detalhes-estornar-item-pedido>
					</div>
				</template>
			</modal>
		</v-form>
		<modal-confirmacao
			titulo-modal="Cancelar documento no processo digital"
			:exibir="exibirConfirmacaoCancelamentoDocumentoProcessoDigital"
			subtitulo-modal="Deseja cancelar o documento antigo automaticamente no processo digital?"
			@confirmar="estornar(true)"
			@fechar-modal="estornar(false)"
		>
		</modal-confirmacao>
	</div>
</template>
<script>
import EstornarItemPedido from '@/views/pages/pedido/acessar/itens/estorno/estornar/EstornarItemPedido.vue'
import Modal from '@/views/components/Modal.vue'
import { actionTypes, mutationTypes } from '@/core/constants'
import validacaoPedido from '@/views/mixins/validacaoPedido'
import arpBpmMixin from '@/views/mixins/bpm/arp-bpm-mixin'
import DetalhesEstornarItemPedido from '@/views/pages/pedido/acessar/itens/estorno/detalhes-estorno/DetalhesEstornarItemPedido.vue'
import { mapState } from 'vuex'
import ModalConfirmacao from '@/views/components/ModalConfirmacao.vue'

export default {
	name: 'modal-estorno-item-pedido',
	components: { ModalConfirmacao, DetalhesEstornarItemPedido, Modal, EstornarItemPedido },
	mixins: [validacaoPedido, arpBpmMixin],
	inject: ['isEditar'],
	props: {
		itens: {
			type: Array,
			required: true,
		},
		exibir: {
			type: Boolean,
		},
		isEstornar: {
			type: Boolean,
			required: true,
		},
	},
	data() {
		return {
			isFormValid: false,
			exibirConfirmacaoCancelamentoDocumentoProcessoDigital: false,
			modalOptions: {
				largura: '600',
			},
			isProcessoDigitalAtivo: this.$store.state.parametrosSistema.isProcessoDigitalAtivo,
		}
	},
	computed: {
		...mapState({
			formulario: (state) => state.itemPedido.estorno.estornar.form,
		}),
		quantidadeEstornoIsValid() {
			return (this.itens.length === 1 && this.formulario.quantidadeEstorno > 0) || this.itens.length > 1
		},
		justificativaValida() {
			return !!this.formulario.justificativa && this.formulario.justificativa.trim().length > 0
		},
		isConfirmarVisivel() {
			return this.isEstornar && this.isFormValid && this.quantidadeEstornoIsValid && this.justificativaValida
		},
		tituloModal() {
			return this.isEstornar ? 'Estornar' : 'Detalhes Estorno'
		},
		nomeBotaoCancelar() {
			return this.isEstornar ? 'CANCELAR' : 'VOLTAR'
		},
		listaPossuiUmItem() {
			return this.itens.length === 1
		},
	},
	methods: {
		tratarEventoEstornar() {
			if (this.$refs.form.validate()) {
				if (this.isProcessoDigitalAtivo) {
					this.abrirModalConfirmacaoCancelamentoDocumentoProcessoDigital()
				} else {
					this.estornar(false)
				}
			}
		},
		abrirModalConfirmacaoCancelamentoDocumentoProcessoDigital() {
			this.exibirConfirmacaoCancelamentoDocumentoProcessoDigital = true
		},
		fecharModalConfirmacaoCancelamentoDocumentoProcessoDigital() {
			this.exibirConfirmacaoCancelamentoDocumentoProcessoDigital = false
		},
		fecharModal() {
			this.$emit('fechar-modal')
			this.$emit('carregar-listagem')
		},
		async estornar(cancelarDocumentoProcessoDigital) {
			if (this.$refs.form.validate()) {
				try {
					await this.$store.dispatch(
						actionTypes.ITEM_PEDIDO.ESTORNO.ESTORNAR.ESTORNAR_ITEM,
						cancelarDocumentoProcessoDigital,
					)

					this.recarregarFormulario()
					this.limparSelecaoItensExterno()
					this.mostrarNotificacaoSucessoDefault()
					this.fecharModalConfirmacaoCancelamentoDocumentoProcessoDigital()
					this.fecharModal()
				} catch (e) {
					this.fecharModalConfirmacaoCancelamentoDocumentoProcessoDigital()
				}
			}
		},
		recarregarFormulario() {
			this.$refs.form.reset()
			this.$store.commit(mutationTypes.ITEM_PEDIDO.ESTORNO.ESTORNAR.RESET_FORM)
		},
		limparSelecaoItensExterno() {
			if (!this.listaPossuiUmItem) {
				this.$store.commit(mutationTypes.ITEM_PEDIDO.RESET_ITENS_SELECIONADOS)
				this.$store.commit(mutationTypes.ITEM_PEDIDO.SET_TODOS_ITENS_SELECIONADOS, false)
			}
		},
	},
}
</script>
